import React, { useEffect, useState } from "react";
import { ChangeTitle, encrypt, toAbsoluteUrl } from "../../helpers/Reusable";
import { Link } from "react-router-dom";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import { setCookie } from "../../helpers/CookieComponent";

const Article = () => {
  ChangeTitle("Article");
  const [articleMenu, setArticleMenu] = useState("Account");
  const [categoryList, setCategoryList] = useState([]);

  // Article Category API Call
  const viewCatogoryList = async () => {
    var response = await postData(
      "article/category/list",
      {},
      apiHeader(false)
    );
    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const categoryData = data.map((data) => {
        return {
          id: data._id,
          categoryName: data.categoryName,
        };
      });
      setCategoryList(categoryData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewCatogoryList();
  }, []);
  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Article Category
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full h-full grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-10 article-menu">
            {categoryList.map((data, i) => (
              <Link
                to="/articlelist"
                onClick={() => {
                  setCookie("articleCategoryId", data.id, {});
                  setCookie("articleCategoryName", encrypt(data.categoryName), {});
                }}
                className="w-full h-full"
              >
                <div
                  className="w-full h-[15vh] md:h-[10vh] xl:h-[10vw] p-[3%] flex justify-items-center cursor-pointer am-box"
                  onClick={() => setArticleMenu(data.categoryName)}
                >
                  <div
                    className={
                      articleMenu === data.categoryName
                        ? "w-full h-full flex justify-center items-center cursor-pointer text-center amb-name amb-name-active"
                        : "w-full h-full flex justify-center items-center cursor-pointer text-center amb-name"
                    }
                  >
                    <h1>{data.categoryName}</h1>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Article;
